/*
 * Copyright (c) 2026, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you've
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) =>
  createStyles({
    publicHeader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: theme.spacing(2),
      padding: theme.spacing(2, 4),
      width: '100%',
      boxSizing: 'border-box',
      [theme.breakpoints.down('xs')]: {
        padding: theme.spacing(2),
      },
    },
    logo: {
      // Below the smallest breakpoint the buttons take priority over the
      // wordmark, which shrinks rather than wrapping the row.
      minWidth: 0,
      [theme.breakpoints.down('xs')]: {
        width: theme.spacing(18),
      },
    },
  })
);
